import type { IAward } from "@/interfaces/IAward";

// Static list — awards change a couple of times a year, so they live in the
// bundle rather than behind an API call.
//
// `title` and `event` are English strings that double as i18n keys: add the
// French wording to src/i18n/locales/fr/translations.json, and English needs no
// entry because i18n falls back to the key itself.
//
// TODO(pakville): the three PLACEHOLDER entries below are scaffolding. Replace
// them with real awards or delete them; they render verbatim in production.
const awards: IAward[] = [
  {
    id: "startupfest-2024-grandmothers-choice",
    title: "Women-Led Top Venture Canada",
    event: "Spring Impact",
    location: "Canada",
    date: new Date(2026, 3, 1),
  },
  {
    id: "placeholder-1",
    title: "Accolades Finalist — Sustainable Development",
    event: "West Island of Montréal Chamber of Commerce",
    location: "Montréal, QC, Canada",
    date: new Date(2025, 5, 1),
  },
  {
    id: "placeholder-2",
    title: "Prix atelier des possibilités",
    event: "Batimatech",
    location: "Montréal, QC, Canada",
    date: new Date(2024, 8, 1),
  },
  {
    id: "placeholder-3",
    title: "Grandmothers' Choice Award",
    event: "Startupfest",
    location: "Montréal, QC, Canada",
    date: new Date(2024, 6, 1),
  },
];

export default awards;
